import React from 'react';
import { SitesTable } from '../../components';
import {useCurrentUser} from "../../contexts/UserContext";
import Unauthorized from "../Unauthorized/Unauthorized";

const Sites = () => {
    const {hasCapability, user} = useCurrentUser();

    return (
        <div className='app__sites'>
            {user != null
                ? hasCapability('Sites_Table')
                    ? <SitesTable/>
                    : <Unauthorized/>
                : <div className='app__unauthorized'>Fetching user data...</div>
            }
        </div>
    );
}

export default Sites;
